// export default  "http://192.168.55.12:3001"
// export default 'http://192.168.55.12:5050' // dektop
// export default 'http://localhost:3900' // mac m1
// export default 'http://192.168.55.9:3001' // note acer
// export default 'http://192.168.55.18:3001' // note gui
//  export default 'http://localhost:3900' // local note sanches
export default 'https://api-myoplay.anysolve.com.br' // local 

